import { Component, EventEmitter, Input, Output } from "@angular/core";
import { OrderLine } from "../split-payment";

@Component({
  selector: "app-split-items",
  templateUrl: "./split-items.html",
  styleUrls: ["./split-items.scss"],
  standalone: false
})
export class SplitItemsComponent {
  @Input() items: OrderLine[] = [];
  @Input() selectedQty: Record<string, number> = {};
  @Input() billAmount = 0;
  @Input() totalRemaining = 0;

  @Output() incItem = new EventEmitter<string>();
  @Output() decItem = new EventEmitter<string>();
}
